/*
 * SPDX-FileCopyrightText: 2022 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ProductFacetNavigationComponent} from '@spartacus/storefront';

@Component({
    selector: 'aimo-product-facet-navigation',
    templateUrl: './aimo-product-facet-navigation.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AimoProductFacetNavigationComponent extends ProductFacetNavigationComponent implements OnInit {
    @Input() mobileUI: boolean;
    @Output() openFacet = new EventEmitter<boolean>();

    ngOnInit() {
        this.isOpen$.subscribe(
            o => this.openFacet.emit(o)
        );
    }
}
